export default class {
    #baseUrl = 'https://city-map.innsbruck.gv.at/stadtplan/'

    getUrl(type, coordinates) {
        const url = new URL(`${this.#baseUrl}synservice`)
        url.search = new URLSearchParams({
            image_format: 'data_only',
            project: 'Website_Widget',
            view: type,
            query_identify_mw: type,
            returnKey_identify_mw: 'ID',
            action: 'feature_mwm',
            geometry: `${coordinates.x} ${coordinates.y}`,
            scale: 1128, //18055.954822
        })

        const generatedUrl = url.toString();
        console.log('generated identify url: ', generatedUrl)

        return generatedUrl
    }
}
